import sanitizeHtml from 'sanitize-html'

const defaultOptions: sanitizeHtml.IOptions = {
  allowedAttributes: {
    '*': ['class', 'style'],
    a: ['href', 'target', 'rel'],
  },
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('sanitized-html', {
    mounted(el, binding) {
      el.innerHTML = sanitizeHtml(binding.value, defaultOptions)
    },
    updated(el, binding) {
      if (binding.value !== binding.oldValue) {
        el.innerHTML = sanitizeHtml(binding.value, defaultOptions)
      }
    },
  })
})
